import React, {PureComponent} from 'react';
import {Button, Col, Container, Row, Card, CardBody, ButtonToolbar} from 'reactstrap';
import MetricsGauge from './components/MetricsGauge';
import {connect} from 'react-redux';
import FtdsVsSignups from './components/FtdsVsSignups';
import LoadingProgress from '../../components/LoadingProgress'
import {
    fetchMainDashboardDataIfNeeded
} from '../../redux/actions/MainDashboardActions';
import {fetchSalesDataIfNeeded} from '../../redux/actions/SalesActions'
import {fetchCustomeraDataIfNeeded} from '../../redux/actions/CustomersActions';
import ReactQueryParams from 'react-query-params';
import ProvidersStat from '../../components/ProvidersStat'
import ProvidersTotal from "../../components/ProvidersTotal";
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
import MaterialTable from '../../components/table/material_table/MaterialTable'
import DateSelector from '../../components/DateSelector'
import SalesItems from '../sales/components/SalesItems';
import PieScreen from "../../components/PieScreen";
import * as environment from '../../../src/modules/environment.js';

import * as TextManager from "../../modules/languages/TextManager";

import EditStoreForm from '../settings/components/EditStoreForm'
import {
    admin_manager_delete,
    admin_open_store_update_form,
    fetchAdminDataIfNeeded
} from "../../redux/actions/AdminActions";
import InternetCheck from '../customers/components/InternetCheck'
import ModalCode from "./components/ModalCode";
import ModalCheckLine from "./components/ModalCheckLine";
import * as http from "../../modules/http";

const directCosts = `${process.env.PUBLIC_URL}/img/directCosts.png`;


class DefaultDashboard extends ReactQueryParams {

    constructor(props) {
        super(props);
        this.state = {
            dealTypeDetail: [],
            isFirst: true,
            timerLoaded: false,
            showAddStore: false
        }
    }

    componentDidMount() {
        this.props.dispatch(fetchMainDashboardDataIfNeeded(this.queryParams));
        this.props.dispatch(fetchSalesDataIfNeeded());
        this.props.dispatch(fetchAdminDataIfNeeded(this.queryParams));
    }

    testFunc = () => {
        /*http.postToServer(
            'api_auto/deal/test?dealId=' + 93347,
            {},
            (response) => {
                console.log("ok");
            },
            (response) => {
                console.log('error');
            }
        );*/

        http.postToServer(
            'api_auto/deal/get?token=123123123123&user_id=' + 56484,
            {},
            (response) => {
                console.log("ok");
            },
            (response) => {
                console.log('error');
            }
        );
    };

    getMetaForStoreTable = (obj) => {
        let res = {name: TextManager.getCurrentTextResource().Stores.stores, metrics: []};

        let filterNames = obj ? Object.getOwnPropertyNames(obj) : [];

        for (let indx in filterNames) {
            let col = filterNames[indx];

            let label = TextManager.getCurrentTextResource().Stores[col];
            res.metrics.push({
                id: col,
                label: label,
                numeric: false,
                disablePadding: true
            })
        }
        res.metrics.reverse();
        return res;
    };

    getCustomerData = () => {
        this.props.dispatch(fetchCustomeraDataIfNeeded(this.queryParams));
    };

    showImageNewTab = (type) => {
        let tImage = new Image();
        tImage.src = type;

        let w = window.open("", '_blank');
        //w.document.write(tImage.outerHTML);
        //w.document.write("<img style='object-fit: contain;height:810px;width:100%' src='" + type + "'/>");
        w.document.write("<body style='text-align:center;'>" +
            "<hr>" +
            "<div class='box'><img id='geeks' GFG='250' style='object-fit: contain;height:160px;width:100%' src='" + type + "'/></div><hr>" +
            "<button type='button' onclick='zoomin()'>Zoom-In</button>" +
            "<button type='button' onclick='zoomout()'>Zoom-Out</button>" +
            "<script type='text/javascript'>" +
            "function zoomin() { var GFG = document.getElementById('geeks'); var currHeight = GFG.clientHeight;" +
            "GFG.style.height = (currHeight + 40) + 'px';}" +
            "function zoomout() { var GFG = document.getElementById('geeks'); var currHeight = GFG.clientHeight;" +
            "GFG.style.height = (currHeight - 40) + 'px';}" +
            "</script></body>"
        )

    };

    render() {

        let userType = undefined;
        let isManger = false;
        let isAdmin = false;
        let isScreen = false;

        let isMobile = environment.isMobile();

        if (this.props.userData && this.props.userData.data && this.props.userData.data.userType) {

            userType = this.props.userData.data.userType;
            isManger = this.props.userData.data.isManger;
            isAdmin = this.props.userData.data.isAdmin;
            isScreen = this.props.userData.data.is_screen;
        }

        if (isScreen && !this.state.timerLoaded) {
            setInterval(this.getCustomerData, 5 * 60 * 1000);
            this.setState({timerLoaded: true});
        }

        let tmpNewDealsCnt = 0;
        let tmpLetterCnt = 0;
        if (isScreen && this.props.customerData) {
            for (let i = 0; i < this.props.customerData.length; i++) {
                if (this.props.customerData[i].status === 1) {
                    tmpNewDealsCnt += this.props.customerData[i].numOfLines;
                }
                if (this.props.customerData[i].lu_by_user_type === environment.ListUserTypesEnum.Store) {
                    tmpLetterCnt += this.props.customerData[i].numOfLines;
                }
            }
        }
        let dataLetterDeals = [{value: tmpLetterCnt, fill: '#70bbfd'}];
        let dataNewDeals = [{value: tmpNewDealsCnt, fill: '#f6da6e'}];

        let showAddStore = false;

        if (this.props.userData && this.props.userData.data && this.props.userData.data.id) {
            if (environment.ListManagersAddStore.includes(this.props.userData.data.id)) showAddStore = true;
        }

        return (
            <Container className='dashboard'>
                <style>
                    {`
                        .card-body {
                        box-shadow: 0 10px 30px 1px rgba(0, 0, 0, 0.06);
                        }
                    `}
                </style>

                {this.props.status === 'request' &&
                <Row>
                    <LoadingProgress/>
                </Row>
                }

                {this.props.status === 'error' &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>
                }

                {/*this.props.isShow && this.props.userData && this.props.userData.data &&
                !this.props.userData.data.isAdmin && !this.props.userData.data.isManager &&
                <Modal color='success' title={TextManager.getCurrentTextResource().Text.hello} noCancel
                       message={this.props.userData.data.name}
                       approve={() => this.props.dispatch(main_dashbaord_hide_hello())}/>
                */}

                {this.props.status === 'success' && !isScreen &&
                <span>
                    <Row>
                        <Col md={3} md={12}>
                            <Card>
                                <CardBody style={{padding: "1.25rem"}}>
                                    {/*isAdmin && <span onClick={(e) => {this.testFunc()}}>TEST</span>*/}
                                    <h3 style={{textAlign: 'right'}}>{/*userType !== 5 && <span style={{marginRight: '15px', color: 'green'}}>מוקד התפעול לשירותך 0733998090 </span>*/}
                                        {TextManager.getCurrentTextResource().Text.dashboardName}</h3>
                                    <div style={{display: 'flex', height: isMobile ? '90%' : '100%', width: '90%'}}>
                                      <ButtonToolbar className='custom_dashboard_header_panel'>
                                        <DateSelector endpoint='dashboard'/>
                                          {<div style={{marginLeft: isMobile ? 0 : '100px'}}>
                                              <Button color='primary' size='sm' style={{color: 'black'}}
                                                  onClick={(e) => {
                                                      e.preventDefault();
                                                      window.open("http://www.qtdmobile.com/", '_blank');
                                                  }}>קישור כניסה לפריפייד</Button>
                                          </div>}
                                          <InternetCheck/>
                                          <ModalCode color='primary'
                                                     title='קוד מוסד'
                                                     header>
                                              <Button outline color={'primary'}
                                                      size='sm'
                                                      style={{width: '100%'}}
                                              >קוד מוסד</Button>
                                          </ModalCode>
                                          <div>
                                              <Button color='primary' size='sm' outline
                                                  onClick={(e) => {
                                                      e.stopPropagation();
                                                      this.showImageNewTab(directCosts)
                                                  }}>עלויות הוראת קבע</Button>
                                          </div>
                                          <ModalCheckLine color='primary'
                                                          title='?בדיקה באיזה חברה הקו נמצא'
                                                          header>
                                              <Button outline color={'danger'} //style={{color: 'black'}}
                                                      size='sm'
                                              >?באיזה חברה הקו נמצא</Button>
                                          </ModalCheckLine>

                                          {showAddStore && <div>
                                              <Button color='success' size='sm' style={{color: 'black'}}
                                                      onClick={(e) => {
                                                          const store = {
                                                              id: 0,
                                                              username: '',
                                                              name: '',
                                                              city: '',
                                                              address: '',
                                                              storeId: 0,
                                                              handle_name: ''
                                                          };
                                                          this.props.dispatch(admin_open_store_update_form(store));
                                                          this.setState({showAddStore: !this.state.showAddStore})
                                                      }}>להוסיף חנות</Button>
                                          </div>}
                                      </ButtonToolbar>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    {this.state.showAddStore &&
                    <EditStoreForm onClose={() => this.setState({showAddStore: !this.state.showAddStore})}/>}

                    {this.props.salesStatus === 'success' &&
                    <Row>
                        <Col md={12} lg={12}>
                            <SalesItems items={this.props.sales}/>
                        </Col>
                    </Row>}

                    {(userType !== 5 && userType !== 6) && <Row>
                        {this.props.userData && this.props.userData.data &&
                        (this.props.userData.data.isAdmin || this.props.userData.data.isManager) &&
                        <Col>
                            <MetricsGauge data={this.props.data.metrics} metricKey="activeStores"
                                          metricName={TextManager.getCurrentTextResource().Text.activeStores}/>
                        </Col>}

                        <Col>
                            <MetricsGauge data={this.props.data.metrics} metricKey="newUsers"
                                          metricName={TextManager.getCurrentTextResource().Text.newUsers}/>
                        </Col>
                        {(isManger || isAdmin || (userType && userType === 2)) &&
                        <Col>
                            <MetricsGauge data={this.props.data.metrics} metricKey="newLines"
                                          metricName={TextManager.getCurrentTextResource().Text.newLines}/>
                        </Col>}

                        {this.props.userData && this.props.userData.data &&
                        (this.props.userData.data.isAdmin || this.props.userData.data.isManager) &&
                        <Col>
                            <MetricsGauge data={this.props.data.metrics} metricKey="newStores"
                                          metricName={TextManager.getCurrentTextResource().Text.newStores}/>
                        </Col>}
                    </Row>}
                    {(userType !== 5 && userType !== 6) && <Row>
                        <FtdsVsSignups data={this.props.data.metrics}/>
                    </Row>}
                    {(userType !== 5 && userType !== 6) && <Row>
                        <ProvidersStat data={this.props.data.providers}/>
                        <ProvidersTotal data={this.props.data.providersTotal}/>
                    </Row>}
                    {this.props.userData && (this.props.userData.data.isManager || this.props.userData.data.isAdmin) && (userType !== 5 && userType !== 6) &&
                    <MaterialTable data={this.props.data.stores} noPaddingCard
                                   meta={this.getMetaForStoreTable(this.props.data.stores[0])}/>
                    }
              </span>
                }

                {this.props.status === 'success' && isScreen &&
                <span>
                    <Row>
                        <PieScreen text='לקוחות מעטפה' data={dataLetterDeals} type='envelope'/>
                        <PieScreen text='לקוחות חדשים' data={dataNewDeals} type='new'/>
                    </Row>
                </span>
                }

            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        status: state.mainDashboard.status,
        isShow: state.mainDashboard.isShow,
        data: state.mainDashboard.data,
        userData: state.userData,
        sales: state.sales.data,
        salesStatus: state.sales.status,
        customerData: state.customers.data
    };
};

export default withRouter(connect(mapStateToProps)(DefaultDashboard))